export default "__VITE_ASSET__Pnfvf19F__"